import { useState } from "react";
import { toast } from "sonner";
import { PageHeader } from "../components/PageHeader";
import { api } from "../lib/api";

const PAGES = {
  despre: {
    eyebrow: "Despre noi",
    title: "Un boutique, un singur brand.",
    sections: [
      ["De ce THULE", "Am ales să lucrăm exclusiv cu THULE pentru că nu cunoaștem un alt brand care să îmbine la fel de natural ingineria, siguranța și designul. Un cărucior THULE nu este doar un produs pentru copil – este un obiect pe care îl folosești cu plăcere ani la rând."],
      ["Ce înseamnă Cassia Concept", "Cassia Concept este un boutique online curat, aerisit, cu puține produse alese cu grijă. Fiecare model din catalog este prezentat cu toate imaginile, specificațiile și schițele de dimensiuni, iar echipa noastră te ajută online să alegi în funcție de felul în care trăiești: oraș, alergare, bicicletă, călătorii."],
      ["Transparență", "Acest site este un demo de prezentare. Datele companiei, condițiile comerciale, politicile de livrare și retur vor fi completate și verificate înainte de lansare."],
    ],
  },
  termeni: {
    eyebrow: "Legal",
    title: "Termeni și condiții",
    sections: [
      ["Statutul acestui site", "Conținutul prezentat este un demo de prezentare. Nu se încheie contracte de vânzare, nu se procesează plăți și nu se expediază produse."],
      ["Prețuri", "Prețurile afișate sunt orientative, preluate din surse publice pentru scopuri demonstrative, și pot diferi de prețurile finale la lansare."],
      ["Proprietate intelectuală", "THULE și denumirile produselor sunt mărci înregistrate ale Thule Group. Imaginile sunt utilizate exclusiv în scop de prezentare internă."],
      ["Actualizare", "Termenii și condițiile complete vor fi redactate și publicate înainte de lansarea comercială."],
    ],
  },
  confidentialitate: {
    eyebrow: "Legal",
    title: "Politica de confidențialitate",
    sections: [
      ["Date colectate în demo", "Formularele din acest demo (comandă, contact, newsletter) stochează datele introduse exclusiv pentru testarea fluxului și pot fi șterse oricând."],
      ["Fără procesare reală", "Nu transmitem date către procesatori de plăți, curieri sau servicii de email în această fază."],
      ["Drepturile tale", "La lansare, politica completă va detalia drepturile conform GDPR: acces, rectificare, ștergere, portabilitate, opoziție."],
    ],
  },
  cookies: {
    eyebrow: "Legal",
    title: "Politica de cookies",
    sections: [
      ["Ce folosim acum", "Demo-ul folosește doar stocare locală în browser (localStorage) pentru coș, favorite, comparare și contul demo. Nu folosim cookie-uri de marketing sau analiză."],
      ["La lansare", "Vom afișa un banner de consimțământ și o politică detaliată pentru toate categoriile de cookies utilizate."],
    ],
  },
};

export function InfoPage({ slug }) {
  const page = PAGES[slug];
  return (
    <div data-testid={`info-page-${slug}`}>
      <PageHeader eyebrow={page.eyebrow} title={page.title} crumbs={[{ label: page.title }]} testId={`info-header-${slug}`} />
      <div className="container-cc grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-8 lg:col-start-3 divide-y divide-black/10 border-t border-black/10">
          {page.sections.map(([h, t]) => (
            <section key={h} className="py-10 grid grid-cols-1 sm:grid-cols-12 gap-4">
              <h2 className="sm:col-span-4 font-serif text-2xl">{h}</h2>
              <p className="sm:col-span-8 text-[#5A5A5A] leading-relaxed">{t}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}

export function ContactPage() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/contact", form);
      setSent(true);
      toast.success("Mesaj trimis", { description: "Îți răspundem în cel mai scurt timp (demo)." });
    } catch {
      toast.error("Verifică datele introduse");
    }
  };
  return (
    <div data-testid="contact-page">
      <PageHeader eyebrow="Contact" title="Hai să vorbim." description="Pentru consultanță online la alegerea căruciorului sau a scaunului auto și întrebări despre compatibilități Thule." crumbs={[{ label: "Contact" }]} testId="contact-header" />
      <div className="container-cc grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4 space-y-8 text-sm">
          <div><p className="eyebrow mb-2">Magazin online</p><p className="text-[#5A5A5A]">Exclusiv online, livrare în toată România<br />Datele firmei vor fi completate ulterior</p></div>
          <div><p className="eyebrow mb-2">Program</p><p className="text-[#5A5A5A]">Luni – Vineri, 10:00 – 19:00<br />Sâmbătă, 10:00 – 15:00</p></div>
          <div><p className="eyebrow mb-2">Email</p><p className="text-[#5A5A5A]">contact@cassiaconcept.ro</p></div>
          <div><p className="eyebrow mb-2">Date firmă</p><p className="text-[#5A5A5A]">Vor fi completate înainte de lansare.</p></div>
        </div>
        <div className="lg:col-span-7 lg:col-start-6">
          {sent ? (
            <div data-testid="contact-success" className="surface p-10"><p className="font-serif text-3xl">Mulțumim.</p><p className="text-[#5A5A5A] mt-2">Mesajul tău a fost înregistrat în demo.</p></div>
          ) : (
            <form onSubmit={submit} data-testid="contact-form" className="space-y-5">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <label className="block"><span className="eyebrow block mb-2">Nume</span><input data-testid="contact-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="input-cc" /></label>
                <label className="block"><span className="eyebrow block mb-2">Email</span><input data-testid="contact-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="input-cc" /></label>
              </div>
              <label className="block"><span className="eyebrow block mb-2">Mesaj</span><textarea data-testid="contact-message" required rows={6} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="input-cc h-auto py-3" /></label>
              <button data-testid="contact-submit" className="btn-primary">Trimite mesajul</button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
